module.exports = __webpack_public_path__ + "img/us.1566642f.svg";